import { render, staticRenderFns } from "./ExchangeDialog.vue?vue&type=template&id=3bcb0fbe&scoped=true"
import script from "./ExchangeDialog.vue?vue&type=script&lang=js"
export * from "./ExchangeDialog.vue?vue&type=script&lang=js"
import style0 from "./ExchangeDialog.vue?vue&type=style&index=0&id=3bcb0fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcb0fbe",
  null
  
)

export default component.exports